import React from 'react'

import HeaderTitle from '../../../components/HeaderTitle'
import Description from '../../../components/Description'
import RadiusedButton from '../../../components/RadiusedButton'

import mobileImg from '../../../resources/images/kvailifika-mobile.svg'
import mobileImgThreeD from '../../../resources/images/mobile-illustration.png'
import forbesImage from '../../../resources/images/forbes-text.svg'
import entrepreneurImage from '../../../resources/images/entrepreneur-text.svg'
import bloombergImage from '../../../resources/images/bloomberg-text.svg'

import TableLayoutSvg from '../../../resources/images/transformedToSvg/table-layout-anim.svg'
import DocVerificationAnimation from '../../../resources/images/transformedToSvg/doc-verification-new.svg'
import useWindowDimension from '../../../hooks/useWindowDimension'

import {
	StyledHeaderTitle,
	StyledButtonContainer,
	StyledMainContainer,
	StyledRightContainer,
	StyledLeftContainer,
	StyledInnerRightContainer,
	StyledMobileImgKvalifiKa,
	StyledDesktopImgKvalifiKa,
	StyledKvalifikaHeader,
	StyledImageListContainer,
	StyledLogoContainer
} from './KvaliHeaderStyle'

const KvaliHeader = ({ headerTitle, headerDescription, hideLogoList, headerLogoName }) => {
	const { windowSize } = useWindowDimension()

	return (
		<StyledMainContainer href='headerContainer'>
			<StyledKvalifikaHeader headerLogoName={headerLogoName}>
				<StyledLeftContainer headerLogoName={headerLogoName}>
					<StyledHeaderTitle>
						<HeaderTitle start value={headerTitle ? headerTitle : 'homePageTitle'} />
						<Description
							value={headerDescription ? headerDescription : 'homePageDescription'}
							textColor='#264445'
							textMaxWidth='481px'
							start
						/>
					</StyledHeaderTitle>
					<StyledButtonContainer>
						{/* <RadiusedButton
							hrefValue={`https://admin.kvalifika.ge/signup?lang=${i18n.language}`}
							value='tryForFree'
						/> */}
						<RadiusedButton
							hrefValue="https://cal.com/bekat"
							value='bookADemo'
						/>
						{/* <RadiusedButton
							hrefValue="https://admin.kvalifika.ge/signup"
							value='Sign Up'
						/> */}
					</StyledButtonContainer>
					{!hideLogoList && (
						<StyledImageListContainer>
							<StyledLogoContainer>
								<img src={bloombergImage} alt={''} />
							</StyledLogoContainer>
							<StyledLogoContainer>
								<img src={forbesImage} alt={''} />
							</StyledLogoContainer>
							<StyledLogoContainer>
								<img src={entrepreneurImage} alt={''} />
							</StyledLogoContainer>
						</StyledImageListContainer>
					)}
				</StyledLeftContainer>
				<StyledRightContainer headerLogoName={headerLogoName}>
					<StyledInnerRightContainer>
						{/* main page header */}
						{windowSize.width > 1200 && !headerLogoName && (
							<>
								<StyledDesktopImgKvalifiKa>
									<TableLayoutSvg />
								</StyledDesktopImgKvalifiKa>
								<StyledMobileImgKvalifiKa>
									<img src={mobileImgThreeD} alt='' width='230' height='447' />
								</StyledMobileImgKvalifiKa>
							</>
						)}
						{windowSize.width < 1200 && windowSize.width > 576 && !headerLogoName && (
							<StyledDesktopImgKvalifiKa>
								<TableLayoutSvg />
							</StyledDesktopImgKvalifiKa>
						)}
						{windowSize.width < 576 && !headerLogoName && (
							<StyledMobileImgKvalifiKa>
								<img src={mobileImg} alt='' />
							</StyledMobileImgKvalifiKa>
						)}
						{headerLogoName && (
							<StyledDesktopImgKvalifiKa headerLogoName={headerLogoName}>
								<DocVerificationAnimation />
							</StyledDesktopImgKvalifiKa>
						)}
					</StyledInnerRightContainer>
				</StyledRightContainer>
			</StyledKvalifikaHeader>
		</StyledMainContainer>
	)
}

export default KvaliHeader
